export const blockIconsBusinessandpaymentsAccountBalanceNew = (
	<span className='material-symbols-outlined'>account_balance</span>
);
